export enum CurrencyType {
  USD = "$",
  GBP = "£",
  EUR = "€",
  CAD = "CA$",
}
